import {
  type HttpHandler,
  type HttpRequestParamsOverride,
  type HttpResponseOverride,
} from "@anna-money/anna-web-lib/api";
import { isObject } from "@anna-money/anna-web-lib/utils";
import { type AuthStore } from "./authStore";
import { type Authenticator } from "./authenticator";
import { UnauthenticatedError } from "./errors";

const accountIsClosedErrorCode = 1005;
export class AuthenticationHandler implements HttpHandler {
  private readonly _authenticator: Authenticator;
  private readonly _authStore: AuthStore;

  constructor(authenticator: Authenticator, authStore: AuthStore) {
    this._authenticator = authenticator;
    this._authStore = authStore;
  }

  async handleRequest(request: HttpRequestParamsOverride): Promise<HttpRequestParamsOverride> {
    return {
      ...request,
      headers: {
        ...request.headers,
        Authorization: `Bearer ${this._authenticator.accessToken}`,
      },
    };
  }

  async handleResponse(_: HttpRequestParamsOverride, response: HttpResponseOverride<any>): Promise<void> {
    if (!this._isAuthenticated(response)) {
      this._authStore.reset();
      throw new UnauthenticatedError();
    }
  }

  private _isAuthenticated(response: HttpResponseOverride<any>): boolean {
    if (response.status === 401) {
      return false;
    }
    const isAccountClosed =
      response.status === 403 &&
      response.type === "json" &&
      isObject(response.data) &&
      isObject(response.data.error) &&
      response.data.error.code === accountIsClosedErrorCode;
    return !isAccountClosed;
  }
}
